import { combineReducers } from 'redux'
import authReducer from './authReducer'
import verifiedReducer from './verifiedReducer'
import displayReducer from './displayReducer'
import modalReducer from './modalReducer'

export default combineReducers({
    auth: authReducer,
    verifiedUser: verifiedReducer,
    display: displayReducer,
    modals: modalReducer
})



// WEBPACK FOOTER //
// ./resources/js/redux/reducers/index.js